import Carousel from "./carousel"
import CardCarousel from "../CardCarousel/CardCarousel"
import CardsCompany from "./cards-company"
import CaseStudyRelated from "./case-study-related"
import CustomerCaseStudies from "./customer-case-studies"
import CustomerHighlights from "./customer-highlights"
import CustomerLogos from "./customer-logos"
import CustomerMonotoneLogos from "./customer-monotone-logos"
import DevHubPromoAll from "./devhub-promo-all"
import DevHubPromoEdTech from "./devhub-promo-edtech"
import DevHubPromoFinServ from "./devhub-promo-finserv"
import DevHubPromoPublishing from "./devhub-promo-publishing"
import DevHubPromoRetail from "./devhub-promo-retail"
import DevHubPromoHospitality from "./devhub-promo-hospitality"
import DevHubPromoSaaS from "./devhub-promo-saas"
import DevHubPromoStreaming from "./devhub-promo-streaming"
import Form from "./form"
import Image from "./image"
import Menu from "./menu"
import NestedPageSection from "./nested-page-section"
import OSSCards from "./oss-cards"
import PageSectionHero from "./page-section-hero"
import PageSectionCustomers from "./page-section-customers"
import PageSectionRow from "./page-section-row"
import Person from "./person"
import ResourceFile from "./resource-file"
import ResourceLink from "./resource-link"
import Text from "./text"
import TestimonialsCarousel from "./testimonials-carousel"
import Video from "./video"
import ContactUsTiles from "./contact-us-tiles"
import ContactUsMap from "./contact-us-map"
import GlobalCapacity from "./globalCapacity"

const ComponentMap = {
  blockCarousel: Carousel,
  blockCustomerCaseStudies: CustomerCaseStudies,
  blockCustomerHighlights: CustomerHighlights,
  blockCustomerLogos: CustomerLogos,
  blockCustomerMonotoneLogos: CustomerMonotoneLogos,
  casestudyRelated: CaseStudyRelated,
  cardCarousel: CardCarousel,
  cardsCompany: CardsCompany,
  contactUsTiles: ContactUsTiles,
  contactUsMap: ContactUsMap,
  ContentfulForm: Form,
  ContentfulImage: Image,
  ContentfulNavigationMenu: Menu,
  ContentfulContentGroup: NestedPageSection,
  ContentfulPageSectionCustomers: PageSectionCustomers,
  ContentfulPerson: Person,
  ContentfulResourceFile: ResourceFile,
  ContentfulResourceLink: ResourceLink,
  ContentfulText: Text,
  ContentfulVideo: Video,
  "devHubPromo-all": DevHubPromoAll,
  "devHubPromo-edtech": DevHubPromoEdTech,
  "devHubPromo-finserv": DevHubPromoFinServ,
  "devHubPromo-publishing": DevHubPromoPublishing,
  "devHubPromo-retail": DevHubPromoRetail,
  "devHubPromo-saas": DevHubPromoSaaS,
  "devHubPromo-hospitality": DevHubPromoHospitality,
  "devHubPromo-streaming": DevHubPromoStreaming,
  "oss-cards": OSSCards,
  globalCapacity: GlobalCapacity,
  pageSectionHero: PageSectionHero,
  pageSectionRow: PageSectionRow,
  testimonialsCarousel: TestimonialsCarousel,
}

export default ComponentMap
